import { FieldType } from '@framework/core/Enums';
import { IEntityModelField, IEntityModel } from '@framework/interfaces/IEntityModel';
export interface IPartyAddressTypeFields {
		id?: any;
		status?: any;
		datestamp?: any;
		changedById?: any;
		name?: any;
}

export class PartyAddressTypeFields extends Array<IEntityModelField> {
	public id: IEntityModelField = { name: "id", displayName: "Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true, keyField: true };
	public status: IEntityModelField = { name: "status", displayName: "Status", fieldType: FieldType.Int, pattern: "NameGeneric", required: true };
	public datestamp: IEntityModelField = { name: "datestamp", displayName: "Datestamp", fieldType: FieldType.DateTime, pattern: "NameGeneric", required: true };
	public changedById: IEntityModelField = { name: "changedById", displayName: "Changed By Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true };
	public name: IEntityModelField = { name: "name", displayName: "Name", fieldType: FieldType.String, pattern: "NameGeneric", required: true };

	constructor() {
		super();
		this.push(this.id);
		this.push(this.status);
		this.push(this.datestamp);
		this.push(this.changedById);
		this.push(this.name);
	}
}

export class PartyAddressTypeDTO implements IEntityModel {
	protected partyAddressTypeName: string = "PartyAddressTypeModel";
	protected partyAddressTypeKeyField: string = "id";
	protected partyAddressTypeDisplayName: string = "Party Address Type|Party Address Types";
	protected partyAddressTypeFields = new PartyAddressTypeFields();
	public get name(): string { return this.partyAddressTypeName };
	public get keyField(): string { return this.partyAddressTypeKeyField };
	public get displayName(): string { return this.partyAddressTypeDisplayName };
	public get fields(): PartyAddressTypeFields { return this.partyAddressTypeFields };

	constructor() {};
}
